import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'
import PaperList from '@/views/PaperList.vue'
import Editor from '@/views/Editor.vue'
import EditorTest from '@/views/EditorTest.vue'
import { getStorageSync } from '@/utils/uni-app'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/paperlist',
    name: 'PaperList',
    component: PaperList,
    meta: { requiresAuth: true }
  },
  {
    path: '/editor',
    name: 'Editor',
    component: Editor,
    meta: { requiresAuth: true }
  },
  {
    path: '/editor-test',
    name: 'EditorTest',
    component: EditorTest,
    meta: { requiresAuth: true }
  },
  {
    path: '/summary',
    name: 'Summary',
    component: () => import('@/views/Summary.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue')
  },
  {
    path: '/painter',
    name: 'Painter',
    component: () => import('@/views/Painter.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/ai-coloring-list',
    name: 'AiColoringList',
    component: () => import('@/views/AiColoringList.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/image-generator',
    name: 'ImageGenerator',
    component: () => import('@/views/ImageGenerator.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/extreme-color',
    name: 'ExtremeColor',
    component: () => import('@/views/ExtremeColor.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/wallet',
    name: 'Wallet',
    component: () => import('@/views/Wallet.vue'),
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = getStorageSync('token')

  if (to.meta.requiresAuth && !token) {
    next('/login')
  } else {
    next()
  }
})

// 全局错误处理：吞掉导航取消 / 重复导航 / 导航失败 类异常
// 避免控制台出现 "Uncaught (in promise) Error: Navigation cancelled/duplicated"
const isNavigationError = (err) => {
  if (!err) return false
  const name = err.name || ''
  const type = err.type || ''
  const msg = String(err.message || err)
  return (
    name === 'NavigationDuplicated' ||
    name === 'NavigationCancelled' ||
    name === 'NavigationAborted' ||
    name === 'NavigationFailed' ||
    type === 'navigation' ||
    msg.includes('Navigation cancelled') ||
    msg.includes('Navigation duplicated') ||
    msg.includes('Avoided redundant navigation') ||
    msg.includes('Navigation aborted')
  )
}

// Vue Router 4 风格：捕获 push/replace 返回的 Promise rejection
const originalPush = router.push.bind(router)
router.push = function (location) {
  return originalPush(location).catch((err) => {
    if (isNavigationError(err)) return // 吞掉常见导航错误
    return Promise.reject(err)         // 其它错误继续抛
  })
}
const originalReplace = router.replace.bind(router)
router.replace = function (location) {
  return originalReplace(location).catch((err) => {
    if (isNavigationError(err)) return
    return Promise.reject(err)
  })
}

// Vue Router 3 风格：onError 兜底
if (typeof router.onError === 'function') {
  router.onError((err) => {
    if (isNavigationError(err)) return
    console.error('[router] unhandled error', err)
  })
}

export default router
